module.exports = __webpack_public_path__ + "docs/privacy.48c17a8f60a6e809d2d913307bb948a3.html";